import { render, staticRenderFns } from "./CommunityPublishModal.vue?vue&type=template&id=13ec3763"
import script from "./CommunityPublishModal.vue?vue&type=script&lang=js"
export * from "./CommunityPublishModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports